module.exports = __webpack_public_path__ + "img/pdf.63a061e1.svg";